import { css } from "@emotion/react";

import { SpacingToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";

export const container = css`
  position: relative;
  overflow: hidden;
  background: linear-gradient(96deg, #eee8ff 0%, #faf0e8 80%, #fff4dd 120%);

  &::after {
    content: "";
    position: absolute;
    width: 244px;
    height: 97px;
    left: 16%;
    bottom: -98px;
    background: linear-gradient(180deg, #ffc694 0%, #ff9994 100%);
    filter: blur(70px);
  }

  &::before {
    content: "";
    position: absolute;
    width: 500px;
    height: 74px;
    left: 40%;
    bottom: -36px;
    background: linear-gradient(275.53deg, #b7c0fa 20.56%, #f1ddff 77.46%);
    filter: blur(20px);
  }
`;

export const logo = css`
  height: 20px;

  @media (max-width: ${ResponsiveBreakpoint.Tablet}px) {
    display: none;
  }
`;

export const banner = css`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  gap: var(${SpacingToken.Spacing5});
  align-items: center;
  justify-content: center;
  padding: var(${SpacingToken.Spacing4});

  @media (max-width: ${ResponsiveBreakpoint.Mobile}px) {
    flex-direction: column;
  }
`;

export const button = css`
  z-index: 1;
  display: flex;
  flex-direction: row;
  gap: var(${SpacingToken.Spacing1});
`;
